export function diffTime(date1: Date, date2: Date): number {
    return Math.abs(date1.getTime() - date2.getTime())
}

export function diffDays(date1: Date, date2: Date): number {
    const diff = diffTime(date1, date2)
    if (diff < 86400000) {
        return 0
    }
    return Math.ceil(diffTime(date1, date2) / (1000 * 60 * 60 * 24))
}

export function formatDate(dateString: string): string {
    const date = new Date(dateString)
    const now = new Date()

    let formatted = date.toLocaleString('pt-BR').split(' ')[0]

    const days = diffDays(date, now)
    if (days > 1) {
        formatted = `${formatted} (${days}d)`
    }

    return formatted
}
